import axios from 'src/api/Api';
import {
    GET_ACCOUNT_DATA_SUCCESS,
    GET_ACCOUNT_DATA_FAILURE,
    SET_FAVORITE_SUCCESS,
    SET_FAVORITE_FAILURE,
    GET_ACCOUNT_DETAILS_SUCCESS,
    GET_ACCOUNT_DETAILS_FAILURE,
    UPDATE_ACCOUNT_DETAILS_SUCCESS,
    UPDATE_ACCOUNT_DETAILS_FAILURE,
    GET_PHYSICIAN_DETAILS_SUCCESS,
    GET_PHYSICIAN_DETAILS_FAILURE,
    SET_FAVORITE_PHYSICIAN_SUCCESS,
    SET_FAVORITE_PHYSICIAN_FAILURE,
    GET_PHYSICIAN_DATA_SUCCESS,
    GET_PHYSICIAN_DATA_FAILURE,
    UPDATE_PHYSICIAN_NOTE_SUCCESS,
    UPDATE_PHYSICIAN_NOTE_FAILURE,
    GET_ACCOUNTS_SUCCESS,
    GET_ACCOUNTS_FAILURE,
    SET_FAVORITE_ASSOCIATE_SUCCESS,
    SET_FAVORITE_ASSOCIATE_PHYSICIAN_SUCCESS,
    SET_ACCOUNT_FAVORITE_PHYSICIAN_SUCCESS,
    GET_ACCOUNT_DATA_FROM_SEARCH_SUCCESS,
    GET_PHYSICIAN_FROM_SEARCH_DATA_SUCCESS,
    SET_FAVORITE_SEARCH_SUCCESS,
    SET_ACCOUNT_FAVORITE_PHYSICIAN_SEARCH_SUCCESS,
    GET_PHYSICIAN_FAV_STATUS_SUCCESS,
    GET_PHYSICIAN_FAV_STATUS_FAILURE,
    GET_ACCOUNT_FAV_STATUS_SUCCESS,
    GET_ACCOUNT_FAV_STATUS_FAILURE,
    GET_ACCOUNTS_LIST_FAILURE,
    GET_ACCOUNTS_LIST_SUCCESS,
    GET_SPECIALTY_FILTER_DATA_SUCCESS,
    GET_SPECIALTY_FILTER_DATA_FAILURE,
} from '../actions';
import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getAccountDetails(action) {
    // const city = action.payload
    //     ? action.payload.city
    //         ? action.payload.city
    //         : ''
    //     : '';
    // const accountNameOrNumber = action.payload
    //     ? action.payload.accountNameOrNumber
    //         ? action.payload.accountNameOrNumber
    //         : ''
    //     : '';
    // const state = action.payload
    //     ? action.payload.state
    //         ? action.payload.state
    //         : ''
    //     : '';
    // const page = action.payload.page ? action.payload.page : 0;
    // const pageParam={page:pageNum}
    const params = convertObjectToQueryParams(action.payload);
    try {
        const result = yield axios({
            method: 'get',
            url: `occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/accounts/list?pageLimit=50&${params}`,
            //  url: `occ/v2/${localStorage.getItem('baseSiteId')}/accounts/list?isFavorite=false&pageLimit=25&pageNum=${page}&searchCityParam=${city}&searchStateParam=${state}&searchAccountParam=${accountNameOrNumber}&sortOrder=ASC&sortParam=ACCOUNTNAME`,
        }).then((response) => response.data);

        if (action.fromSearch) {
            yield put({
                type: GET_ACCOUNT_DATA_FROM_SEARCH_SUCCESS,
                payload: result,
            });
        } else {
            yield put({
                type: GET_ACCOUNT_DATA_SUCCESS,
                payload: result,
            });
        }
    } catch (error) {
        const url = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/accounts/list?pageLimit=50&${convertObjectToQueryParams(action.payload)}`;
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ACCOUNT_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

// export function* getShipToAddressDetails(){
//     try{
//         const result = yield axios({
//             method: 'get',
//             url: 'http://localhost:3004/shipToAddress',
//         }).then((response) => response.data);
//         console.log(result[0],'result');
//         yield put({type: GET_SHIP_TO_ADDRESS_SUCCESS, payload: result});
//     } catch(e){
//         console.log(e);
//         yield put({
//             type:GET_ANNOUNCEMENTS_FAILURE,
//             templateError: errorHandler('503'),
//         });
//     }
// }
export default function* getAccount(action) {
    const params = convertObjectToQueryParams({
        ...action.payload,
        isOrderListingPage: false,
    });

    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/aardt/accounts?orderType=&${params}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);

        if (result.accounts?.length > 0) {
            const accountsLists = result.accounts.map((account) => {
                return {
                    ...account,
                    id: account.accountId,
                    name: account.accountName,
                };
            });

            result.accounts = [...accountsLists];
        }

        yield put({ type: GET_ACCOUNTS_SUCCESS, data: result });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ACCOUNTS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
export function* getAccountDetailss(action) {
    const accountId = action.payload.accountId;
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/accounts/details?sapPartnerId=${accountId}`;
    try {
        const result = yield axios({
            method: 'get',
            url: url,
        }).then((response) => response.data);
        yield put({
            type: GET_ACCOUNT_DETAILS_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ACCOUNT_DETAILS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* updateAccountDetails(action) {
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/accounts/updatedetails`;
    const value = action.payload.carrierNotes;
    const carrier = action.payload.carrier;
    const carrierPickup = action.payload.carrierPickupNotifications;
    const accountNote =
        action.payload.noteDetails && action.payload.noteDetails;
    const carrierLabel = action.carrierValue;
    try {
        const result = yield axios
            .put(url, { ...action.payload })
            .then((response) => response.data);

        result.accountNumber = action.payload.accountNumber;
        result.carrierNotes = value;
        result.accountNote = accountNote;
        result.carrierPickup = carrierPickup;
        result.carrier = carrier;
        result.carrierLabel = carrierLabel;
        yield put({
            type: UPDATE_ACCOUNT_DETAILS_SUCCESS,
            payload: result || {},
            requestPayload: action.payload,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: UPDATE_ACCOUNT_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: error.Error,
        });
    }
}
export function* setFavoriteIcon(action) {
    const accountId = action.payload;
    const value = action.value;
    const selectedTerritorycode = action.selectedTerritorycode;
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/accounts/favorite?accountId=${accountId}&favorite=${value}`;
    try {
        const result = yield axios({
            method: 'put',
            url: url,
        }).then((response) => response.data);
        result.accountId = accountId;
        result.favValue = value;
        result.selectedTerritorycode = selectedTerritorycode;
        if (action.isAssoicate) {
            yield put({
                type: SET_FAVORITE_ASSOCIATE_SUCCESS,
                payload: result,
            });
        } else if (action.fromSearch) {
            yield put({
                type: SET_FAVORITE_SEARCH_SUCCESS,
                payload: result,
            });
        } else {
            yield put({ type: SET_FAVORITE_SUCCESS, payload: result });
        }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SET_FAVORITE_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getPhysicianDetailss(action) {
    const physicianId = action.payload.accountId;
    const { physicianDropdownZGMorePhysicianVisibility } = yield select(
        (state) => ({
            physicianDropdownZGMorePhysicianVisibility:
                state.loginReducer.physicianDropdownZGMorePhysicianVisibility,
        })
    );
    try {
        let url1;
        if (physicianDropdownZGMorePhysicianVisibility === 'VISIBLE') {
            url1 = `occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/physician/ZGdetails?physicianId=${physicianId}`;
        } else {
            url1 = `occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/physician/detail?physicianId=${physicianId}`;
        }
        const result = yield axios({
            method: 'get',
            // url: `occ/v2/${localStorage.getItem('baseSiteId')}/physician/detail?physicianId=${physicianId}`,
            url: url1,
        }).then((response) => response.data);
        yield put({ type: GET_PHYSICIAN_DETAILS_SUCCESS, payload: result });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url1,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PHYSICIAN_DETAILS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* setFavoritePhysician(action) {
    const physicianId = action.payload;
    const value = action.value;
    const isFromAccount = action.isFromAccount;
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/physician/favorite?isFavorite=${value}&physicianId=${physicianId}`;
    try {
        const result = yield axios({
            method: 'put',
            url: url,
        }).then((response) => response.data);
        result.physicianId = physicianId;
        result.favValue = value;
        if (action.isAssoicate) {
            yield put({
                type: SET_FAVORITE_ASSOCIATE_PHYSICIAN_SUCCESS,
                payload: result,
            });
        } else if (isFromAccount) {
            yield put({
                type: SET_ACCOUNT_FAVORITE_PHYSICIAN_SUCCESS,
                payload: result,
            });
        } else if (action.isFromSearch) {
            yield put({
                type: SET_ACCOUNT_FAVORITE_PHYSICIAN_SEARCH_SUCCESS,
                payload: result,
            });
        } else {
            yield put({
                type: SET_FAVORITE_PHYSICIAN_SUCCESS,
                payload: result,
            });
        }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SET_FAVORITE_PHYSICIAN_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getPhysicianDetails(action) {
    const params = convertObjectToQueryParams(action.payload);
    const { physicianDropdownZGMorePhysicianVisibility } = yield select(
        (state) => ({
            physicianDropdownZGMorePhysicianVisibility:
                state.loginReducer.physicianDropdownZGMorePhysicianVisibility,
        })
    );
    let url1;
    if (physicianDropdownZGMorePhysicianVisibility === 'VISIBLE') {
        url1 = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/physician/ZGphysicianList?pageLimit=50&${params} `;
    } else {
        url1 = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/physician/list?pageLimit=50&${params}`;
    }
    try {
        const result = yield axios({
            method: 'get',
            // url: `occ/v2/${localStorage.getItem('baseSiteId')}/physician/list?pageLimit=50&${params}`,
            url: url1,
        }).then((response) => response.data);
        // yield put({
        //     type: GET_PHYSICIAN_DATA_SUCCESS,
        //     payload: result,
        // });
        if (action.fromSearch) {
            yield put({
                type: GET_PHYSICIAN_FROM_SEARCH_DATA_SUCCESS,
                payload: result,
            });
        } else {
            yield put({
                type: GET_PHYSICIAN_DATA_SUCCESS,
                payload: result,
            });
        }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url1,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PHYSICIAN_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* updatePhysicianNote(action) {
    const notesss = action.payload.notes;
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/physician/updateNotes`;
    try {
        const result = yield axios
            .put(url, { ...action.payload })
            .then((response) => response.data);
        result.phyNotes = notesss;
        yield put({
            type: UPDATE_PHYSICIAN_NOTE_SUCCESS,
            payload: result || {},
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: UPDATE_PHYSICIAN_NOTE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: error.Error,
        });
    }
}

export function* getFavPhysicianStatus(action) {
    const params = convertObjectToQueryParams(action.payload);
    const { physicianDropdownZGMorePhysicianVisibility } = yield select(
        (state) => ({
            physicianDropdownZGMorePhysicianVisibility:
                state.loginReducer.physicianDropdownZGMorePhysicianVisibility,
        })
    );
    let url1;
    if (physicianDropdownZGMorePhysicianVisibility === 'VISIBLE') {
        url1 = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/physician/ZGphysicianList?pageLimit=50&${params} `;
    } else {
        url1 = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/physician/list?pageLimit=50&${params}`;
    }
    try {
        const result = yield axios({
            method: 'get',
            url: url1,
            // url: `occ/v2/${localStorage.getItem('baseSiteId')}/physician/list?pageLimit=50&${params}`,
            //  url: `occ/v2/${localStorage.getItem('baseSiteId')}/accounts/list?isFavorite=false&pageLimit=25&pageNum=${page}&searchCityParam=${city}&searchStateParam=${state}&searchAccountParam=${accountNameOrNumber}&sortOrder=ASC&sortParam=ACCOUNTNAME`,
        }).then((response) => response.data);
        // yield put({
        //     type: GET_PHYSICIAN_DATA_SUCCESS,
        //     payload: result,
        // });
        yield put({
            type: GET_PHYSICIAN_FAV_STATUS_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url1,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PHYSICIAN_FAV_STATUS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getFavAccountStatus(action) {
    const params = convertObjectToQueryParams(action.payload);
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/accounts/list?pageLimit=50&${params}`;

    try {
        const result = yield axios({
            method: 'get',
            url: url,
            //  url: `occ/v2/${localStorage.getItem('baseSiteId')}/accounts/list?isFavorite=false&pageLimit=25&pageNum=${page}&searchCityParam=${city}&searchStateParam=${state}&searchAccountParam=${accountNameOrNumber}&sortOrder=ASC&sortParam=ACCOUNTNAME`,
        }).then((response) => response.data);

        yield put({
            type: GET_ACCOUNT_FAV_STATUS_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ACCOUNT_FAV_STATUS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getAccountList(action) {
    const params = convertObjectToQueryParams(action.payload);
    const { physicianDropdownZGMorePhysicianVisibility } = yield select(
        (state) => ({
            physicianDropdownZGMorePhysicianVisibility:
                state.loginReducer.physicianDropdownZGMorePhysicianVisibility,
        })
    );
    let url1;
    if (physicianDropdownZGMorePhysicianVisibility === 'VISIBLE') {
        url1 = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/physician/ZGphysicianList?pageLimit=50&${params} `;
    } else {
        url1 = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/physician/list?pageLimit=50&${params}`;
    }
    try {
        const result = yield axios({
            method: 'get',
            url: url1,
            // url: `occ/v2/${localStorage.getItem('baseSiteId')}/physician/list?pageLimit=50&${params}`,
            //  url: `occ/v2/${localStorage.getItem('baseSiteId')}/accounts/list?isFavorite=false&pageLimit=25&pageNum=${page}&searchCityParam=${city}&searchStateParam=${state}&searchAccountParam=${accountNameOrNumber}&sortOrder=ASC&sortParam=ACCOUNTNAME`,
        }).then((response) => response.data);
        // yield put({
        //     type: GET_PHYSICIAN_DATA_SUCCESS,
        //     payload: result,
        // });
        yield put({
            type: GET_ACCOUNTS_LIST_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url1,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ACCOUNTS_LIST_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getSpecialtyFilterData(action) {
    const params = convertObjectToQueryParams(action.payload);
    const { physicianDropdownZGMorePhysicianVisibility } = yield select(
        (state) => ({
            physicianDropdownZGMorePhysicianVisibility:
                state.loginReducer.physicianDropdownZGMorePhysicianVisibility,
        })
    );
    let url1;
    if (physicianDropdownZGMorePhysicianVisibility === 'VISIBLE') {
        url1 = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/physician/ZGphysicianList?pageLimit=50&${params} `;
    } else {
        url1 = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/physician/list?pageLimit=50&${params}`;
    }

    try {
        const result = yield axios({
            method: 'get',
            url: url1,
            // url: `occ/v2/${localStorage.getItem('baseSiteId')}/physician/list?pageLimit=50&${params}`,
            //  url: `occ/v2/${localStorage.getItem('baseSiteId')}/accounts/list?isFavorite=false&pageLimit=25&pageNum=${page}&searchCityParam=${city}&searchStateParam=${state}&searchAccountParam=${accountNameOrNumber}&sortOrder=ASC&sortParam=ACCOUNTNAME`,
        }).then((response) => response.data);
        // yield put({
        //     type: GET_PHYSICIAN_DATA_SUCCESS,
        //     payload: result,
        // });
        yield put({
            type: GET_SPECIALTY_FILTER_DATA_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url1,
            requestPayload: action.payload
        });
        yield put({
            type: GET_SPECIALTY_FILTER_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
